import type { FiltersContext } from '@/components/providers/FiltersProvider/filters-provider.types';
import type { Context } from 'react';
import { useContext } from 'react';

import { filtersContext } from '@/components/providers/FiltersProvider/filters-provider.context';

export const useFilters = <TValues = object>() =>
  useContext(filtersContext as unknown as Context<FiltersContext<TValues>>);
